import { render, staticRenderFns } from "./EditBenefitsModal.vue?vue&type=template&id=59b5e758&scoped=true"
import script from "./EditBenefitsModal.vue?vue&type=script&lang=js"
export * from "./EditBenefitsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59b5e758",
  null
  
)

export default component.exports